import { CustomizationFailure, CustomizationGroup, CustomizationTaskDefinition } from '../../models/customization';
import { createStringIdAdapter } from './common/string-id-adapter';

export const customizationGroupAdapter = createStringIdAdapter<CustomizationGroup>();

export const customizationTaskDefinitionAdapter = createStringIdAdapter<CustomizationTaskDefinition[]>();

export const customizationFailureAdapter = createStringIdAdapter<CustomizationFailure>();
